var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { registerForLocalization, provideLocalizationService as intl } from '@progress/kendo-react-intl';
import { messages, noRecords } from './messages';
/**
 * Represents the TreeListNoRecords component.
 * The component is rendered when the `data` property of the TreeList is an empty array or undefined.
 */
var TreeListNoRecords = /** @class */ (function (_super) {
    __extends(TreeListNoRecords, _super);
    function TreeListNoRecords() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden
     */
    TreeListNoRecords.prototype.render = function () {
        return this.props.children || intl(this).toLanguageString(noRecords, messages[noRecords]);
    };
    return TreeListNoRecords;
}(React.Component));
export { TreeListNoRecords };
registerForLocalization(TreeListNoRecords);
//# sourceMappingURL=TreeListNoRecords.js.map